module.exports = "::ng-deep .filter-professional-concept .mat-card-header-text {\n  width: 100%; }\n\n.mm-full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/professional-concept/edit-professional-concept/edit-professional-concept.component.scss
// module id = ./src/app/main/content/pages/management/professional-concept/edit-professional-concept/edit-professional-concept.component.scss
// module chunks = main